module.exports = __webpack_public_path__ + "static/media/Liliana.daf365de.png";